import React from 'react';
import classnames from 'classnames';

export type TypeProps =
  | 'text'
  | 'email'
  | 'number'
  | 'password'
  | 'tel'
  | 'date'
  | 'time'
  | 'checkbox'
  | 'radio'
  | 'textarea';

export interface InputProps extends React.HTMLAttributes<HTMLElement> {
  disableControlClass?: boolean;
  className?: string;
  type?: TypeProps;
  [key: string]: any;
}

const Input: React.FunctionComponent<InputProps> = ({
  disableControlClass = false,
  className,
  ...props
}) => (
  <input
    className={classnames(
      !disableControlClass && 'input__control',
      props.type === 'date' && 'input__date',
      className
    )}
    {...props}
  />
);

export default Input;
